/// <amd-module name="Artifacts/Upack/commands/Promote" />
import { getPromoteCommandCreator } from "Artifacts/Root/protocols/Commands";
import { UpackActions } from "Artifacts/Upack/redux";

export const createPromoteCommand = getPromoteCommandCreator(UpackActions.promote);
